import { render, staticRenderFns } from "./AuthTable.vue?vue&type=template&id=329d3179&scoped=true"
import script from "./AuthTable.vue?vue&type=script&lang=js"
export * from "./AuthTable.vue?vue&type=script&lang=js"
import style0 from "./AuthTable.vue?vue&type=style&index=0&id=329d3179&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329d3179",
  null
  
)

export default component.exports